module.exports = __webpack_public_path__ + "img/icon-instagram.140fb02d.svg";